import useAsync from 'Hooks/useAsync';
import { getCategoriesApi } from '../API/tableAPI/groupAPI';

const useCategories = (categoryName?: string) => {
  return useAsync(() => getCategoriesApi(), { deps: [categoryName] });
};

export default useCategories;
